module.exports = __webpack_public_path__ + "img/green_035.bedad964.png";